import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/fr'

dayjs.locale('fr')
dayjs.extend(relativeTime)

export function formatRelativeDate(value: Date): string {
    return (dayjs() as any).to(dayjs(value))
}
